<div class="atos-loading-spinner-container" [ngClass]="'spinner-' + size">
  <div class="spinner"></div>
  <p *ngIf="message">{{ message | translate }}</p>
</div>
